import { createStore as reduxCreateStore, combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import ui from './ui';
import uiToBeCached from './ui-to-be-cached';
import contact from './contact';
import basicBusiness from './basic-business';
import business from './business';
import bank from './bank';
import basicPersonal from './basic-personal';
import security from './security';
import jcaSecurity from './jca-security'
import plusShipping from './plus-shipping';
import timer from './timer';
import channel from './channel';
import refCode from './refCode';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['ui'],
};

const rootReducer = combineReducers({
  ui,
  uiToBeCached,
  contact,
  basicBusiness,
  business,
  bank,
  basicPersonal,
  security,
  timer,
  channel,
  refCode,
  jcaSecurity,
  plusShipping,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);
const windowExist = typeof window === 'object';

const createStore = () =>
  reduxCreateStore(
    persistedReducer,
    windowExist && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  );

export default createStore;
